import * as GoogleTagManager from '../modules/GoogleTagManager';

const ShawContract = window.ShawContract || {};
const customPatternsModal = document.getElementById('customPatternsModal');
const customPatternsModalProdNumber = document.getElementById('customModal-prodNumber');
const customPatternsModalSize = document.getElementById('customModal-size');
const customPatternsModalMachineType = document.getElementById('customModal-machineType');
const customPatternsModalPatternType = document.getElementById('customModal-patternType');
const customizeBtnNode = document.getElementById('customize-btn-node');
const imgNode = document.getElementById('img-node');

ShawContract.CustomPatternModal = {

  addEventListenersToOpenModal(selector = '.prod-card .prod-card__img') {
    const btns = document.querySelectorAll(selector);

    if (!btns) {
      return;
    }

    for (let i = 0; i < btns.length; i++) {
      const button = btns[i];
      button.addEventListener('click', this.openModal);
    }
  },

  openModal(event) {
    const button = event.currentTarget;

    imgNode.src = button.getAttribute('data-img');
    customizeBtnNode.href = button.getAttribute('data-customize-url');
    const productNameAttr = button.getAttribute('data-product-name');
    const styleNumberAttr = button.getAttribute('data-style-number');
    const sizeAttr = button.getAttribute('data-size');
    const machineTypeAttr = button.getAttribute('data-machine-type');
    const patternTypeAttr = button.getAttribute('data-pattern-type');
    const list = button.getAttribute('data-list');

    const gtmProductData = {
      id: styleNumberAttr,
      name: styleNumberAttr,
      category: 'Custom Pattern',
      machineType: machineTypeAttr,
      patternType: patternTypeAttr,
      size: sizeAttr,
      list,
    };

    customPatternsModalProdNumber.textContent = `${productNameAttr} ${styleNumberAttr}`;
    customPatternsModalSize.textContent = sizeAttr;
    customPatternsModalMachineType.textContent = machineTypeAttr;
    customPatternsModalPatternType.textContent = patternTypeAttr;

    GoogleTagManager.productImpression(gtmProductData);
    $(customizeBtnNode).on('click', () => GoogleTagManager.productClick(gtmProductData));

    $(customPatternsModal).modal('show');
    $('.modal-backdrop').addClass('bg-transparent');
  },
};

window.ShawContract = ShawContract;
